<template>
  <div class="addAndModify">
    <el-container>
      <el-main ref="main" class="tabWrap">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :rules="rules" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="标题：" prop="title">
                    <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="来文字号：" prop="documentNum">
                    <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="来文单位：" prop="documentFromCompany">
                    <el-input v-model="dataForm.documentFromCompany" placeholder="请输入来文单位" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="收文日期：" prop="documentReceiveDate">
                    <el-date-picker
                        v-model="dataForm.documentReceiveDate"
                        type="date"
                        placeholder="请选择收文日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <div class="sendList">
                    <el-form-item
                        label="部门："
                        label-width="120px"
                        ref="sendListRef"
                        prop="documentDeptJson"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                            v-for="(tag, index) in dataForm.documentDeptJson"
                            @close="closeAttend(tag)"
                            :key="index"
                            closable
                            style="margin-right: 5px;"
                        >{{ tag.name }}</el-tag
                        >
                      </div>
                      <el-button @click="selectParticipanceList('attendDepart')" type="primary"
                      >选择</el-button
                      >
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="16">
                  <el-form-item class="maxWidth" label-width="120px" label="拟办意见：">
                    <el-input v-model="dataForm.comment" type="textarea" :rows="6" placeholder="请输入拟办意见" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="Tab2" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <upload-file
                  :tableList="fileList"
                  @submit="doSubmitFiles">
              </upload-file>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="close()">关闭</el-button>
          <el-button type="info" @click="preserve()">保存</el-button>
        </div>
      </el-footer>
    </el-container>

    <select-dialog
        :visible="selectDialogVisible"
        @close="selectDialogClose"
        title="选择"
        v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import SelectDialog from "@/page/meeting/bill/SelectDialog";
import UploadFile from "@/page/document/manage/uploadFile";
import {
  addReceiveFileService,
  getReceiveDetailService,
  modifyReceiveFileService,
} from "@/services/documentServices";
export default {
  name: "addAndModiify",
  data() {
    return {
      activeName: 'Tab1',
      dataForm:{
        id: '',
        title: '',  // 标题
        documentNum: '',  // 来文字号
        documentFromCompany: '',  // 来文单位
        documentReceiveDate: '',  // 收文日期
        documentDeptJson: [],   //部门数据
        documentDeptId: '', //部门id
        comment: '',  // 拟办意见
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        documentNum: [
          { required: true, message: '请输入来文字号', trigger: 'blur' },
        ],
        documentFromCompany: [
          { required: true, message: '请输入来文单位', trigger: 'change' },
        ],
        documentReceiveDate: [
          { required: true, message: '请选择收文日期', trigger: 'change' },
        ],
        documentDeptJson: [
          { required: true, message: '请选择部门', trigger: 'change' },
        ],
      },
      fileList:[],

      selectDialogVisible: false,
      selectDialogOptions: {},
    }
  },
  components: {
    SelectDialog,
    UploadFile,
  },
  methods: {
    onActive(menuCode) {
      if(this.tabRouteParam.id){
        this.dataForm.id = this.tabRouteParam.id;
        this.getReceiveDetail();
      }else {
        this.dataForm.documentNum = this.getCurrentTime();
      }
      this.documentType = this.tabRouteParam.documentType
    },

    getCurrentTime() {
      let date = new Date();//当前时间
      let year = date.getFullYear() //返回指定日期的年份
      let month = this.repair(date.getMonth() + 1);//月
      let day = this.repair(date.getDate());//日
      let hour = this.repair(date.getHours());//时
      let minute = this.repair(date.getMinutes());//分
      let second = this.repair(date.getSeconds());//秒

      //当前时间
      let curTime = year.toString() + month.toString()  + day.toString() + hour.toString() + minute.toString() + second.toString();
      return curTime;
    },
    //补0
    repair(i){
      if (i >= 0 && i <= 9) {
        return "0" + i;
      } else {
        return i;
      }
    },
    //获取发文详情
    getReceiveDetail(){
      let paramsData = {
        systemFileExternalId: this.dataForm.id
      }
      getReceiveDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm = {
            id: res.data.id,
            title: res.data.title,  //标题
            documentNum: res.data.documentNum,  // 来文字号
            documentFromCompany: res.data.documentFromCompany,  // 来文单位
            documentReceiveDate: res.data.documentReceiveDate,  // 收文日期
            documentDeptJson: res.data.documentDeptId ? [{
              deptId: res.data.documentDeptId,
              name: res.data.documentDeptName
            }]:[],   //部门数据
            documentDeptId: res.data.documentDeptId, //部门id
            comment: res.data.comment,  // 拟办意见
          }
          this.fileList = res.data.attachmentList;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 选择参会人员.可以选择个人，可以选择群组，不可以选择部门
    selectParticipanceList(dataKey) {
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 0,
        dataKey: dataKey
      };
      this.selectDialogVisible = true;
    },
    // 删除列席部门
    closeAttend(tag) {
      let index = this.dataForm.documentDeptJson.indexOf(tag);
      if (index != -1) {
        this.dataForm.documentDeptJson.splice(index, 1);
      }
    },
    // 选择部门和人员
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      const { dataKey } = data;
      let departList = data.departList || [];
      departList.forEach(o => {
        let index = this.dataForm.documentDeptJson.findIndex(
            p => p.id == o.id
        );
        if (index == -1) {
          this.dataForm.documentDeptJson.push({
            deptId: o.id,
            name: o.name
          });
        }
      });
      if(this.dataForm.documentDeptJson.length > 1){
        this.$message.error('部门只能选择一个！');
        this.dataForm.documentDeptJson = [];
      }
    },
    // 修改附件列表后的回调
    doSubmitFiles(files) {
      console.log("doSubmitFiles====", files);
      this.fileList = files;
    },

    //保存
    preserve(){
      if(!this.dataForm.title){
        this.$message.error('请输入标题！');
        return
      }
      if(!this.dataForm.documentNum){
        this.$message.error('请输入来文字号！');
        return
      }
      if(!this.dataForm.documentFromCompany){
        this.$message.error('请输入来文单位！');
        return
      }
      if(!this.dataForm.documentReceiveDate){
        this.$message.error('请选择收文日期！');
        return
      }
      if(this.dataForm.documentDeptJson.length == 0){
        this.$message.error('请选择部门！');
        return
      }
      // if(this.fileList.length == 0){
      //   this.$message.error('请选择上传附件！');
      //   return
      // }


      if(this.documentType == 1){
        this.addReceiveFile();
      }else if(this.documentType == 2){
        this.modifyReceiveFile();
      }
    },
    //新增
    addReceiveFile(){
      let params = {
        ...this.dataForm,
        documentDeptId: this.dataForm.documentDeptJson[0].deptId,
        attachmentList: this.fileList,
      }
      addReceiveFileService(params).then( res => {
        if(res.code == 10000000){
          this.$message.success('新增成功！');
          this.close();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //修改
    modifyReceiveFile(){
      let params = {
        ...this.dataForm,
        documentDeptId: this.dataForm.documentDeptJson[0].deptId,
        attachmentList: this.fileList,
      }
      modifyReceiveFileService(params).then( res => {
        if(res.code == 10000000){
          this.$message.success('修改成功！');
          this.close();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 关闭
    close(){
      if(this.documentType == 1){
        this.bus.$emit("tabClose", "incomingManageAdd");
        this.bus.$emit("navMenuChange", {
          routeId: "incomingManage"
        });
      }else {
        this.bus.$emit("tabClose", "incomingManageModiify");
        this.bus.$emit("navMenuChange", {
          routeId: "incomingManage"
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .addAndModify {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .tabWrap {
      height: calc(100% - 60px);

      /deep/ .el-tabs--top {
        height: 100%;
        overflow: hidden;

        .el-tabs__content {
          height: calc(100% - 140px);
          padding: 0 20px 20px;
          overflow: auto;

          .el-form-item {
            width: 100%;
          }

          .el-checkbox {
            line-height: 40px;
          }

          .el-textarea {
            min-width: 0px !important;
          }
          .el-cascader {
            width: 100%;
          }

          .el-form-item__content {
            width: calc(100% - 150px);

            .el-input {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .sendList {
    /deep/.el-form-item{
      width: 100%;
      display: flex;
      .el-form-item__content {
        width: 78%;
        display: flex;
        .el-input {
          flex: 1;
        }
        .el-button {
          margin-left: 10px;
          height: fit-content;
        }
      }
    }

    .tag-wrapper {
      border: 1px solid #dcdfe6;
      padding: 0 5px;
    }
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
</style>
